import { Link } from "react-router-dom";
import useSWR from "swr";
import { fetchCategories, listCollections } from "@/lib/api";
import { ShareIcons } from "@/components/ShareIcons";

const PAGES = [
  { to: "/", label: "Home" },
  { to: "/archive", label: "Full archive" },
  { to: "/archive?sort=most_viewed", label: "Most viewed" },
  { to: "/collections", label: "Collections" },
  { to: "/pet-rescue-saga", label: "Pet Rescue Saga levels" },
  { to: "/harry-potter-puzzles-spells", label: "Harry Potter levels" },
  { to: "/support", label: "Support the vault" },
  { to: "/about", label: "About" },
];

const slugId = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

function Column({ title, links, testid }) {
  return (
    <nav aria-label={title} data-testid={testid}>
      <div className="mono-label text-[#d95d39]">{title}</div>
      <ul className="mt-4 space-y-2">
        {links.map((l) => (
          <li key={l.to}>
            <Link
              to={l.to}
              data-testid={`${testid}-link-${slugId(l.label)}`}
              className="text-sm text-white/55 hover:text-[#f4f1ea] transition-colors"
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export const SiteFooter = ({ channel }) => {
  const { data: cats } = useSWR("/videos/categories", fetchCategories);
  const { data: cols } = useSWR("/collections", () => listCollections());

  const categories = (cats?.categories || []).map((c) => ({
    to: `/archive?category=${encodeURIComponent(c.name)}`,
    label: c.name,
  }));
  const collections = (cols?.items || [])
    .filter((c) => !/^Pet Rescue Saga level/i.test(c.title || ""))
    .slice(0, 8)
    .map((c) => ({ to: `/collections/${c.slug}`, label: c.title }));

  return (
    <footer className="border-t border-white/10 mt-10 pt-14 pb-10 px-4" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          <Column title="Explore" links={PAGES} testid="footer-explore" />
          <Column title="Categories" links={categories} testid="footer-categories" />
          <div className="col-span-2">
            <Column title="Collections" links={collections} testid="footer-collections" />
          </div>
        </div>
        <div className="mt-12">
          <ShareIcons />
        </div>
        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="mono-label text-white/40">
            {channel?.title || "tobiasdeamon"} // Vault · An unofficial archive
          </div>
          <div className="mono-label text-white/30">
            © {new Date().getFullYear()} · Preserved with reverence
          </div>
        </div>
      </div>
    </footer>
  );
};
